import styled from "styled-components";

import { colors, breakpoints } from "definitions";
import { field } from "basics/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

/* La zona de carga medía 15rem de alto con un ícono de 15rem adentro, que
   ocupaba casi todo el alto y empujaba el texto contra el borde. Ahora el
   ícono acompaña al texto y la caja se ajusta a su contenido. */
export const DropZone = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.6rem;
  box-sizing: border-box;
  width: 100%;
  padding: 2rem;
  /* La caja seguía blanca en los formularios oscuros de administración, con la
     leyenda blanca encima: el texto quedaba invisible. Pinta la misma
     superficie que el resto de los controles (el mixin fieldBox). */
  border: 1.5px dashed
    ${({ mode }) => (mode === "dark" ? field.dark.border : "#b9c6d8")};
  border-radius: 10px;
  background: ${({ mode }) =>
    mode === "dark" ? field.dark.surface : colors.background.white};
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  :hover {
    border-color: ${({ mode }) =>
    mode === "dark" ? colors.fonts.white : colors.icons.yellowGreen};
    background: ${({ mode }) =>
    mode === "dark" ? "rgba(0, 0, 0, 0.28)" : "#f5f9ff"};
  }

  ${breakpoints.phablet} {
    flex-direction: column;
    text-align: center;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${breakpoints.phablet} {
    justify-content: space-between;
  }
`;

export const Legend = styled.span`
  display: block;
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2.1rem;

  color: ${({ mode }) => (mode === "dark" ? "white" : colors.fonts.darkGray)};

  em {
    display: block;
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.8rem;
    color: ${({ mode }) =>
    mode === "dark" ? field.dark.placeholder : "#5b6470"};
  }
`;

export const Files = styled.ul`
  display: grid;
  gap: 0.8rem;
  list-style: none;
  margin: 1.2rem 0 0;
  padding-left: 0;
`;
